"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// SR零售店管理模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/retailorStoreInfo/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetails: function getDetails(id, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/retailorStoreInfo/query/' + id,
      method: 'post',
      cancelToken: cancelToken
    });
  },
  saveItem: function saveItem(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/retailorStoreInfo/save',
      method: 'post',
      data: data
    });
  },
  export: function _export(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/retailorStoreInfo/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  getTrainingList: function getTrainingList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/retailorStoreInfo/list_store_training',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getVisitList: function getVisitList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/retailorStoreInfo/list_store_visit',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  // rtm产品select
  getProductSelect: function getProductSelect(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/app/production/select',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  // rtm产品列表
  getProductList: function getProductList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/app/production/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  }
};